import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  /** Pills rendered inline after the title. */
  badges?: ReactNode;
  /** Right-aligned buttons. */
  actions?: ReactNode;
  children?: never;
}

export function PageHeader({ title, subtitle, badges, actions }: PageHeaderProps) {
  return (
    <div className="mb-5 flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-2xl font-bold text-brand-navy focus:outline-none">{title}</h1>
          {badges}
        </div>
        {subtitle && <div className="mt-1 text-sm text-gray-600">{subtitle}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
